import { readLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { Alert, Grid, Snackbar } from "@mui/material";
import { useState } from "react";


export const PreviewLiquidationRequestView: React.FC<any> = (props:any): JSX.Element => {
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });
    const data = readLocalStorage('previewLiquidationRequest');
    console.log(data?.pdf);

    return (
        <>
        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>
        
        <Grid container style={{ overflow: 'hidden !important', height:'100%', alignItems: 'center', textAlign: 'center'}}>
             <iframe src={data?.pdf} id="pdfVer" height="1000px" width="100%"></iframe>
        </Grid>
        </>
    )
}